import styled from '@emotion/styled';

import { spacing, borderRadius, transitions } from '../tokens';

/**
 * Valores visuais do Checkbox. Paleta de seleção reaproveitada do SelectableCard
 * (mesma divergência: #000FFF vs token primary #000eff — ver design-token-spec-divergence).
 */
export const spec = {
  unchecked: { border: '#D9D9D9', bg: '#FFFFFF' },
  checked: { border: '#000FFF', bg: '#000FFF', check: '#FFFFFF' },
  disabled: { border: '#E8E8E8', bg: '#F0F0F0', check: '#B4B4B4' },
  focus: '#000FFF',
  label: '#3D3D3D',
};

type CheckedProp = { $checked: boolean; $disabled: boolean };

export const CheckboxRoot = styled('label')<{ $disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.sm};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
`;

export const HiddenInput = styled('input')`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;

  &:focus-visible + span {
    outline: 3px solid ${spec.focus};
    outline-offset: 2px;
  }
`;

export const Box = styled('span', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<CheckedProp>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: ${borderRadius.sm};
  border: 1.5px solid
    ${({ $checked, $disabled }) => {
      if ($disabled) return spec.disabled.border;
      return $checked ? spec.checked.border : spec.unchecked.border;
    }};
  background-color: ${({ $checked, $disabled }) => {
    if ($disabled) return spec.disabled.bg;
    return $checked ? spec.checked.bg : spec.unchecked.bg;
  }};
  color: ${({ $disabled }) =>
    $disabled ? spec.disabled.check : spec.checked.check};
  transition: ${transitions.base};

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const LabelText = styled('span')<{ $disabled: boolean }>`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: ${({ $disabled }) => ($disabled ? '#B4B4B4' : spec.label)};
  line-height: 1.5;
`;
